export function required(name, value) {
  if (!value) {
    return "This field is required.";
  }
}
